import {ErrorMessage} from "formik";
import styles from "./CustomErrorMessage.module.css";

interface CustomErrorMessageProps {
  name: string;
}
export default function CustomErrorMessage({name}: CustomErrorMessageProps){
  return(
    <ErrorMessage name={name}>
      {msg => <div className={styles.errorMessage}>{msg}</div>}
    </ErrorMessage>
  );
}